import cognitoAuth from "../cognito";
import api from "../api";

export default {
  state: {
    currentUser: "loading",
    currentUserData: {}
  },
  mutations: {
    setCurrentUser(state, user) {
      state.currentUser = user;
    },
    setCurrentUserData(state, user) {
      state.currentUserData = user;
    }
  },
  actions: {
    initAuth({ commit, dispatch }) {
      cognitoAuth.isAuthenticated((res, loggedIn) => {
        if (loggedIn) {
          api.defaults.headers.Authorization = `Bearer ${res.idToken.jwtToken}`;
          commit("setCurrentUser", res);
          dispatch("loadCurrentUserData");
        } else if (!loggedIn) {
          commit("setCurrentUser", null);
        }
        dispatch("setFullLoaderState", false);
      });
    },
    login({ commit, dispatch, state }, payload) {
      api.defaults.headers.Authorization = `Bearer ${payload.idToken.jwtToken}`;
      commit("setCurrentUser", payload);
      dispatch("loadCurrentUserData");
    },
    async loadCurrentUserData({ commit, rootState, dispatch }) {
      commit("setCurrentUserData", { Result: "Loading" });
      let userData = await api.get("user/CurrentUserData");
      console.log(userData);
      localStorage.setItem("currentUserData", JSON.stringify(userData.data));
      commit("setCurrentUserData", userData.data);
      if (userData.data.Result == "Denied") {
        dispatch("logout");
      }
    },
    changeMandatoryPassword({ commit, dispatch }, payload) {
      cognitoAuth.handleNewPassword(payload);
    },
    logout({ commit }) {
      cognitoAuth.logout((err, result) => {});
      commit("setCurrentUser", null);
    }
  },
  getters: {
    currentUser(state) {
      return state.currentUser;
    },
    currentUserData(state) {
      return state.currentUserData;
    }
  }
};
